import { Component, OnInit, Input, Output, EventEmitter, ElementRef, HostBinding, ViewChild } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { IconModel } from '../../models/icon/icon.model';
import { ButtonModel } from '../../models/button/button.model';
import { MenuItemModel } from '../../models/menu/menu-item.model';
import { MenuItemStylingModel } from '../../models/menu/menu-item-styling.model';
import { MenuItemTemplates } from '../../templates/menu-item.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>CF Menu Item Component</p>
 * <pre>
 * <code>
 * import {{'{'}} MenuItemModel {{'}'}} from 'cedrus-fusion'
 * import {{'{'}} MenuItemStylingModel {{'}'}} from 'cedrus-fusion'
 * <</code>cf-menu-item<code>></code><code><</code><code>/</code>cf-menu-item<code>>
 * </code>
 * </pre>
 */
export class CfMenuItemComponent extends CfCoreComponent implements OnInit {
/**
 * @hidden
 */
notificationClickable = '';
/**
 * @hidden
 */
itemTemplate;
/**
 * <pre>{{'{'}}
 *  display: boolean,							// True or False <b>Default: True</b>
 *  disable: boolean,							// True or False <b>Default: False</b>
 *  buttonProperty: ButtonModel,	// ButtonModel object
 *  divider: boolean,							// If to show divider line under the menu item
 * {{'}'}}
 * </pre>
 * <p>Example</p>
 * <pre>{{'{'}}
 * 	display: true,
 * 	disable: false,
 *  buttonProperty:{{'{'}}
 *  	label: "USD account",
 *    iconProperty:{{'{'}}
 *      name: 'fa-usd',
 *      size: '24px'
 *    {{'}'}},
 *    iconPosition:"left"
 *   {{'}'}}
 *  {{'}'}},
 *  divider: true
 * {{'}'}}
 * </pre>
 */
public properties: MenuItemModel;
/**
 * <pre>
 * 	menuItemStyling:{{'{'}}
 *   //Check Button Component
 *   buttonStyling: ButtonStylingModel
 * {{'}'}}
 * {{'}'}}
 * </pre>
 */
public styling: MenuItemStylingModel;
/**
 * The label for the item
 * @param {?} value
 * @return {?}
 */
set label(value: string) {
    if (this.properties.buttonProperty == null) { this.properties.buttonProperty = new ButtonModel(); }
    this.properties.buttonProperty.label = value;
  }
/**
 * The name of the icon
 * @param {?} value
 * @return {?}
 */
set iconName(value: string) {
    if (this.properties.buttonProperty == null) {
      this.properties.buttonProperty = new ButtonModel({ iconProperty: new IconModel() });
    } else if (this.properties.buttonProperty != null && this.properties.buttonProperty.iconProperty == null) {
      this.properties.buttonProperty.iconProperty = new IconModel();
    }
    this.properties.buttonProperty.iconProperty.name = value;
  }
/**
 * The size of the icon
 * @param {?} value
 * @return {?}
 */
set iconSize(value: string) {
    if (this.properties.buttonProperty == null) {
      this.properties.buttonProperty = new ButtonModel({ iconProperty: new IconModel() });
    } else if (this.properties.buttonProperty != null && this.properties.buttonProperty.iconProperty == null) {
      this.properties.buttonProperty.iconProperty = new IconModel();
    }
    this.properties.buttonProperty.iconProperty.size = value;
  }
/**
 * If to show menu item divider
 * @param {?} value
 * @return {?}
 */
set divider(value: boolean) { this.properties.divider = value; }
/**
 * Emit event on menu item click with item object
 */
public onClick = new EventEmitter();
/**
 * @hidden
 * @return {?}
 */
buttonClick() { this.onClick.emit(this.properties); }
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new MenuItemModel();
    this.styling = new MenuItemStylingModel();
  }
/**
 * It is function for creating Notification click events by using Core Component <b>notificationAction</b> event emmiter.
 * @param {?} notification 	it is json notification object
 * @return {?}
 */
cfNotificationAction(notification) { this.notificationAction.emit(notification); }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    if (this.notificationAction.observers.length > 0) { this.notificationClickable = 'notification-clickable'; }
    this.getMyTemplate('menu-item', MenuItemTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'MENU-ITEM').then( sampler => {
        // console.log('MENU-ITEM', this);
      });
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-menu-item',
  template: "<div *ngIf=\"_inited && properties?.display\" class=\"{{activeTemplate.style?.container?.class}} {{styling?.container?.class}} {{getDynamicClasses(activeTemplate.style?.container?.dynamicClass)}} {{getDynamicClasses(styling?.container?.dynamicClass)}}\" [ngClass]=\"'cf-menu-item-container'\"> <cf-button _buttonScheme=\"mat-menu-item\" [disable]=\"properties?.disable\" [properties]=\"properties?.buttonProperty\" [styling]=\"styling?.buttonStyling\" (onClick)=\"buttonClick()\"> <span class=\"cf-menu-item-content\"><ng-content></ng-content></span> <span *ngIf=\"properties?.notification && (properties?.notification?.value || properties?.notification?.icon)\" class=\"cf-menu-item-notification\"> <cf-notification [settings]=\"properties?.notification\"></cf-notification> </span> </cf-button> <md-divider *ngIf=\"properties?.divider\"></md-divider> </div>",
  styles: [":host { position: relative; z-index: 0; } :host.notification-clickable cf-notification:hover { cursor: pointer; } :host /deep/ .mat-button { text-align: left; } :host /deep/ .mat-menu-item md-icon.mat-icon { color: inherit; } :host /deep/ .cf-menu-item-container > cf-button, :host /deep/ .cf-menu-item-container > cf-button > div, :host /deep/ .cf-menu-item-container > cf-button > div > button { width: 100%; } .cf-menu-item { display: inline-flex; align-items: center; line-height: 0; } .cf-menu-item-label { display: inline-flex; flex-grow: 1; } .cf-menu-item-notification { display: inline-flex; position: relative; z-index: 0; width: 24px; height: 24px; padding-left: 16px; vertical-align: middle; } .cf-menu-item-notification cf-notification { top: auto; right: auto; bottom: auto; left: auto; } .cf-menu-item-notification:empty { display: none !important; } .mat-divider { border-top-color: rgba(0, 0, 0, 0.12); border-top-width: 1px; border-top-style: solid; display: block; } .cf-menu-item[disabled] .cf-menu-item-notification { background: rgba(0, 0, 0, 0.38) !important; } [hidden] { display: none !important; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'notificationClickable': [{ type: HostBinding, args: ['class', ] },],
'itemTemplate': [{ type: ViewChild, args: ['itemTemplate', ] },],
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'label': [{ type: Input, args: ['label', ] },],
'iconName': [{ type: Input, args: ['iconName', ] },],
'iconSize': [{ type: Input, args: ['iconSize', ] },],
'divider': [{ type: Input, args: ['divider', ] },],
'onClick': [{ type: Output },],
};
}

function CfMenuItemComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfMenuItemComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfMenuItemComponent.ctorParameters;
/** @type {?} */
CfMenuItemComponent.propDecorators;
/**
 * @hidden
 * @type {?}
 */
CfMenuItemComponent.prototype.notificationClickable;
/**
 * @hidden
 * @type {?}
 */
CfMenuItemComponent.prototype.itemTemplate;
/**
 * <pre>{{'{'}}
 *  display: boolean,							// True or False <b>Default: True</b>
 *  disable: boolean,							// True or False <b>Default: False</b>
 *  buttonProperty: ButtonModel,	// ButtonModel object
 *  divider: boolean,							// If to show divider line under the menu item
 * {{'}'}}
 * </pre>
 * <p>Example</p>
 * <pre>{{'{'}}
 * 	display: true,
 * 	disable: false,
 *  buttonProperty:{{'{'}}
 *  	label: "USD account",
 *    iconProperty:{{'{'}}
 *      name: 'fa-usd',
 *      size: '24px'
 *    {{'}'}},
 *    iconPosition:"left"
 *   {{'}'}}
 *  {{'}'}},
 *  divider: true
 * {{'}'}}
 * </pre>
 * @type {?}
 */
CfMenuItemComponent.prototype.properties;
/**
 * <pre>
 * 	menuItemStyling:{{'{'}}
 *   //Check Button Component
 *   buttonStyling: ButtonStylingModel
 * {{'}'}}
 * {{'}'}}
 * </pre>
 * @type {?}
 */
CfMenuItemComponent.prototype.styling;
/**
 * Emit event on menu item click with item object
 * @type {?}
 */
CfMenuItemComponent.prototype.onClick;
/** @type {?} */
CfMenuItemComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
